import type { RootState } from "types/redux";

export const getCommunities = (state: RootState) => state.domains.collections.communities;

export const getEditableCollections = (state: RootState) => state.domains.collections.editable;

export const createIsCollectionClientSideSelector = (id: string) => (state: RootState) =>
  state.domains.collections.editable.find((item) => item.id === id)?.is_client_side ?? false;

export const getFeaturedCollections = (state: RootState) => state.domains.collections.featured;

export const getCollectionUploadPending = (state: RootState) => state.domains.collections.isCollectionUploadPending;

export const getCollectionForEditing = (state: RootState) => state.domains.collections.forEditing;

export const getCollectionForViewing = (state: RootState) => state.domains.collections.forViewing.collection;

export const getCollectionForViewingStatus = (state: RootState) => state.domains.collections.forViewing.status;

export const getCollectionForViewingTopicsMeta = (state: RootState) => state.domains.collections.forViewing.topicsMeta;

export const getListedCollections = (state: RootState) => state.domains.collections.listed;

export const getCollectionsNextPageMayExist = (state: RootState) => state.domains.collections.nextPageMayExist;

export const getCollectionsOffset = (state: RootState) => state.domains.collections.offset;

export const getCollectionsStatus = (state: RootState) => state.domains.collections.status;

export const getUploadedImages = (state: RootState) => state.domains.collections.uploadedImageUrls;

export const getUploadedHeroImage = (state: RootState) => state.domains.collections.uploadedImageUrls.hero;
